import type { PatientConsent } from "@/core/types";

export type AdaptedPatientConsent = ReturnType<typeof adaptPatientConsent>;

export function adaptPatientConsent(consent: PatientConsent) {
  return {
    consentAskedBy: consent.consent_asked_by,
    consentAskedByName: consent.consent_asked_by_name,
    consentFormEffectiveDate: consent.consent_form_effective_date,
    consentFormName: consent.consent_form_name,
    consentFormVersion: consent.consent_form_version,
    consentResponse: consent.consent_response,
    consentType: consent.consent_type,
    createdBy: consent.created_by,
    createdDate: consent.created_date,
    entityId: consent.entity_id,
    localTimestamp: consent.local_timestamp,
    responseGivenBy: consent.response_given_by,
    responseGivenByGuardian: consent.response_given_by_guardian,
    responseGivenByName: consent.response_given_by_name,
    sortKey: consent.sort_key,
    timestamp: consent.timestamp,
    ...(consent?.user_file_report_key && { userFileReportKey: consent.user_file_report_key }),
    ...(consent?.user_file_sk && { userFileSK: consent.user_file_sk }),
  };
}
